import { render } from "./ShareholderInformation.vue?vue&type=template&id=2ce02c62&scoped=true"
import script from "./ShareholderInformation.vue?vue&type=script&lang=js"
export * from "./ShareholderInformation.vue?vue&type=script&lang=js"

import "./ShareholderInformation.vue?vue&type=style&index=0&id=2ce02c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce02c62"]])

export default __exports__